/**
 * Admin App Definition Service
 * API: /api/admin/apphub/apps
 *
 * Admin panelinde uygulama tanımı CRUD işlemleri için kullanılır.
 */

import client from '@lib/core/axios.client';
import { API_ENDPOINTS } from '@lib/constants';
import type {
  AppDefinitionDto,
  CreateAppDefinitionRequest,
  UpdateAppDefinitionRequest,
  ReorderAppDefinitionItem,
} from '@/types/api/admin';

export class AdminAppDefinitionService {
  private static instance: AdminAppDefinitionService;

  private constructor() {}

  public static getInstance(): AdminAppDefinitionService {
    if (!AdminAppDefinitionService.instance) {
      AdminAppDefinitionService.instance = new AdminAppDefinitionService();
    }
    return AdminAppDefinitionService.instance;
  }

  /**
   * Tüm uygulama tanımlarını listele (aktif + pasif)
   */
  async getAll(): Promise<AppDefinitionDto[]> {
    const response = await client.get<{ data: AppDefinitionDto[] }>(
      API_ENDPOINTS.ADMIN.APP_DEFINITIONS.LIST
    );
    return response.data;
  }

  /**
   * ID'ye göre uygulama tanımı detayı getir
   */
  async getById(id: string): Promise<AppDefinitionDto> {
    const response = await client.get<{ data: AppDefinitionDto }>(
      API_ENDPOINTS.ADMIN.APP_DEFINITIONS.BY_ID(id)
    );
    return response.data;
  }

  /**
   * Yeni uygulama tanımı oluştur
   */
  async create(data: CreateAppDefinitionRequest): Promise<AppDefinitionDto> {
    const response = await client.post<{ data: AppDefinitionDto }>(
      API_ENDPOINTS.ADMIN.APP_DEFINITIONS.CREATE,
      data
    );
    return response.data;
  }

  /**
   * Uygulama tanımını güncelle
   */
  async update(id: string, data: UpdateAppDefinitionRequest): Promise<AppDefinitionDto> {
    const response = await client.put<{ data: AppDefinitionDto }>(
      API_ENDPOINTS.ADMIN.APP_DEFINITIONS.UPDATE(id),
      data
    );
    return response.data;
  }

  /**
   * Uygulama tanımını sil
   */
  async delete(id: string): Promise<void> {
    await client.delete<{ success: boolean }>(
      API_ENDPOINTS.ADMIN.APP_DEFINITIONS.DELETE(id)
    );
  }

  /**
   * Birden fazla uygulamanın sıralama değerini güncelle
   */
  async reorder(items: ReorderAppDefinitionItem[]): Promise<void> {
    await client.put<{ success: boolean }>(
      API_ENDPOINTS.ADMIN.APP_DEFINITIONS.REORDER,
      items
    );
  }
}

export const adminAppDefinitionService = AdminAppDefinitionService.getInstance();
